import React from "react";

import JackPotLogo from "./JackPotLogo";
import LoginMenu from "./LoginMenu";

import "./../../scss/Header/index.scss";
import {useTranslation} from "react-i18next";

const Header = () => {
  const { t } = useTranslation();
  return (
    <>
      <header className="flex-row header">
        <div className="logo-container flex-col-6 hide-for-mobile">
          <div className="game-logo" />

          <span className="game-name">{t('bets.ls')}</span>
        </div>
        <div className="flex-col-7 align-center">
          <JackPotLogo />
        </div>
        <div className="flex-col-8 right-header-block">
          <LoginMenu />
        </div>
      </header>
    </>
  );
};

export default Header;
